import { SHOW_ALERT, HIDE_ALERT } from "../actionTypes"

export default (state = { message: '' }, action=null) => {
  switch(action.type) {
    case SHOW_ALERT:
      return { ...state, ...action.payload, isError: true }
    case HIDE_ALERT:
      return { ...state, ...action.payload, isError: false }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/alert.js